import React from "react";
import { ArrowLeft, Lock, Play, Star } from "lucide-react";
import { LEVELS } from "../game/levels";
import { playClick } from "../game/sound";

export default function LevelSelect({ save, onBack, onSelect }) {
  return (
    <div className="screen levels-screen" data-testid="levels-screen">
      <div className="screen-container">
        <button
          type="button"
          className="back-btn"
          onClick={() => {
            playClick();
            onBack();
          }}
          data-testid="levels-back-button"
        >
          <ArrowLeft size={16} /> Back
        </button>
        <h2 className="screen-title">Select World</h2>

        <div className="levels-grid">
          {LEVELS.map((lvl) => {
            const unlocked = save.unlockedLevels.includes(lvl.id);
            const completed = save.completedLevels.includes(lvl.id);
            const high = save.highScores[lvl.id] || 0;
            return (
              <button
                key={lvl.id}
                type="button"
                disabled={!unlocked}
                className={`level-card ${unlocked ? "" : "locked"} ${completed ? "completed" : ""}`}
                onClick={() => {
                  if (!unlocked) return;
                  playClick();
                  onSelect(lvl.id);
                }}
                data-testid={`level-card-${lvl.id}`}
              >
                <div className="level-id">L{lvl.id}</div>
                <div className="level-name">{lvl.name}</div>
                <div className="level-sub">{lvl.subtitle}</div>
                <div className="level-meta">
                  <span>{lvl.goal} zombies</span>
                  <span>{lvl.time}s</span>
                </div>
                {completed && (
                  <div className="level-trophy">
                    <Star size={14} fill="#ffd23f" /> {high}
                  </div>
                )}
                <div className="level-cta">
                  {unlocked ? (
                    <>
                      <Play size={16} /> Play
                    </>
                  ) : (
                    <>
                      <Lock size={16} /> Locked
                    </>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
